<template>
  <div class="countdown-wrapper">
    <div class="countdown-content">
      <div class="columns is-gapless">
        <div class="column">
          <br>
          <h1 class="is-size-3 has-text-centered">{{ event.name }} starts in</h1>
          <div class="countdown">
            <div class="metric">
              <span class="value">{{ days }}</span>
              <p
                class="label"
                v-html="days === 1 ? 'Day&nbsp;&nbsp;' : 'Days'"
              />
            </div>
            <div class="metric">
              <span class="value">{{ hours }}</span>
              <p
                class="label"
                v-html="hours === 1 ? 'Hour&nbsp;&nbsp;' : 'Hours'"
              />
            </div>
            <div class="metric">
              <span class="value">{{ minutes }}</span>
              <p
                class="label"
                v-html="minutes === 1 ? 'Minute&nbsp;&nbsp;' : 'Minutes'"
              />
            </div>
            <div class="metric">
              <span class="value">{{ seconds }}</span>
              <p
                class="label"
                v-html="seconds === 1 ? 'Second&nbsp;&nbsp;' : 'Seconds'"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="userNotRegistered && currentUser.role === 'participant'"
        class="columns is-gapless"
      >
        <div class="column">
          <div class="padded">
            <h2 class="is-size-5 has-text-centered">You haven't registered for this event.</h2>
            <br>
            <div class="has-text-centered">
              <RegisterNowButton />
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="columns is-gapless"
      >
        <div class="column">
          <div class="padded">
            <h2 class="is-size-5 has-text-centered">Video submission can only be done during the championship,<br><b>between {{ formatDate(event.eventStartDate, 'MMM Do YYYY') }} and {{ formatDate(event.eventEndDate, 'MMM Do YYYY') }}</b>.<br><br>Don't worry, we'll notify you once they open.</h2>
            <br>
            <h2 class="is-size-5 has-text-centered">In the meantime, keep practicing!</h2>
            <br>
            <div class="has-text-centered">
              <a
                href="https://www.gmaworldchampionships.com/how-it-works/"
                class="button is-primary is-medium"
              >How it Works/Rules</a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import dateMixins from '@/mixins/dates'
import RegisterNowButton from '@/components/inputs/RegisterNowButton'

const dayInSeconds = 86400

export default {
  name: 'Countdown',
  mixins: [dateMixins],
  components: {
    RegisterNowButton
  },
  props: {
    event: {
      type: Object,
      default: () => {
        return {}
      }
    },
    startDate: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      interval: false,
      diff: false,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    }
  },
  mounted () {
    this.interval = setInterval(() => {
      this.diff = this.startDate.diff(moment(), 'seconds')
    }, 1000)
  },
  destroyed () {
    clearInterval(this.interval)
  },
  computed: {
    currentUser () {
      return this.$store.getters['users/currentUser']
    },
    userNotRegistered () {
      return this.currentUser.divisions.filter(e => {
        return e.activeEvent === this.$store.getters.currentEvent._id
      }).length === 0
    }
  },
  watch: {
    diff () {
      let t = moment(this.diff * 1000)
      if (this.diff > dayInSeconds) {
        this.days = this.startDate.diff(moment(), 'days')
        this.hours = t.hours()
        this.minutes = t.minutes()
        this.seconds = t.seconds()
      } else {
        this.days = 0
        this.hours = t.hours()
        this.minutes = t.minutes()
        this.seconds = t.seconds()
      }
    }
  }
}
</script>

<style lang="scss">
  .countdown-wrapper{
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background: $gray-lighter;
    height: calc(100vh - 5rem);
    width: 100%;
    padding-top: 5%;
    overflow: auto;

    > *{
      color: $primary-color;
      font-size: .8em;
    }

    .countdown-content{
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      position: relative;
    }

    // &:before{
    //   content: '';
    //   background-image: url('~@/assets/static/img/kick.jpg');
    //   -webkit-background-size: cover;
    //   -moz-background-size: cover;
    //   -o-background-size: cover;
    //   background-size: cover;
    //   background-position: top center;
    //   background-attachment: fixed;
    //   position: absolute;
    //   width: 100%;
    //   height: 38vh;
    // }

    @include until($tablet) {

      padding-bottom: 10px;
      padding-top: 20%;

      .is-size-3.has-text-centered{
        font-size: 1.5em!important;
      }
    }
  }

  .countdown{
    display: flex;
    justify-content: space-around;
    border-radius: 4px;
    background: $yellow;
    color: $primary-color;
    border: 2px solid $primary-color;
    margin: 1em auto;
    text-align: left;
    width: 90%;
    max-width: 400px;

    .metric{
      display: flex;
      flex-direction: column;
      justify-content: initial;
      align-items: center;
      padding: 2px 0 20px;
    }

    .value{
      font-size: 2em;
    }
    .label{
      color: $primary-color;
      line-height: 1px;
    }
  }

  .padded{
    padding: 0 15px;
  }
</style>
